import { useState } from "react";
import ToggleSwitchTailwind from "./ToggleSwitchTailwind";

const ModalPreviewSection = () => {
  const [valor, setValor] = useState(false);
  const [desconto, setDesconto] = useState(false);
  const [tamanho, setTamanho] = useState(false);

  const getImageName = () => {
    if (valor && desconto && tamanho)
      return "screenshot 3 tamanho valor desconto.png";
    if (valor && desconto) return "screenshot 6 valor desconto.png";
    if (valor && tamanho) return "screenshot 2 tamanho valor.png";
    if (desconto && tamanho) return "screenshot 4 tamanho desconto.png";
    if (valor) return "screenshot 7 valor.png";
    if (desconto) return "screenshot 5 desconto.png";
    if (tamanho) return "screenshot 1 tamanho.png";
    return "screenshot 8.png";
  };

  return (
    <section className="text-center px-4 py-24 max-w-7xl mx-auto">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-700/80">
        Controle o que seu visitante vê
      </h3>
      <h2 className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
        Mostre o necessário e incentive seu cliente a chamar no WhatsApp
      </h2>

      <div className="mt-12 flex justify-center">
        <div className="flex flex-row flex-wrap sm:flex-nowrap items-center sm:items-stretch bg-white rounded-3xl shadow-2xl p-6 sm:p-10 gap-8 w-full max-w-4xl">
          {/* Botões */}
          <div className="flex flex-col justify-center gap-6 w-full sm:w-auto">
            <ToggleSwitchTailwind
              checked={valor}
              onChange={setValor}
              label="Valor"
            />
            <ToggleSwitchTailwind
              checked={desconto}
              onChange={setDesconto}
              label="Desconto"
            />
            <ToggleSwitchTailwind
              checked={tamanho}
              onChange={setTamanho}
              label="Tamanhos"
            />
          </div>

          {/* Imagem */}
          <div className="overflow-hidden rounded-2xl w-full max-w-md shadow-2xl">
            <img
              src={`/variacoesUI/${getImageName()}`}
              alt="Preview da UI personalizada"
              className="shadow-2xl w-full h-auto aspect-[5/4] scale-110 transition-opacity duration-1000 ease-in-out opacity-0 animate-fadeIn object-cover shadow-xl/30"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModalPreviewSection;
